<template>
  <div>
    <!-- Pay All-->
    <a-modal
      v-model="visible"
      :title="`Pay all unpaid student fees ${payAllOrSingle == 'PAYALL' ? '(Group fee payment)' : '(Single fee payment)'}`"
      onOk="handleOk"
      :width="
        this.settings['isMobileView']
          ? 360
          : this.settings['isTabletView']
          ? 560
          : 720
      "
      :destroyOnClose="true"
      style="top: 20px;"
    >
      <template slot="footer">
        <a-button key="back" @click="handleCancel">Cancel</a-button>
        <a-button
          key="submit"
          type="primary"
          :loading="loading"
          v-if="feesToPay.length"
          @click="handleFeePayment"
        >
          Pay Fee
        </a-button>
      </template>
      <a-spin :spinning="spinning">
        <div v-if="studentFeesData">
          <div v-if="feesToPay.length">
            <p v-if="payAllOrSingle === 'PAYALL'" class="mb-2 text-danger">Note: Use Delete (x) button to remove the fee from the group fee payment</p>
            <div class="d-flex justify-content-between align-items-center mb-2">
              <p class="font-weight-bold mb-2 text-muted">Fee details:</p>
<!--              <a-button type="primary" @click="handleReset" >Reset</a-button>-->
            </div>
            <table class="table table-sm">
              <thead>
                <tr>
                  <th>Fee</th>
                  <th>Amount</th>
                  <th>Fine</th>
                  <th>Dis.</th>
                  <th>Dis. %</th>
                  <th>Due</th>
                  <th>Total</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="fee in feesToPay" :key="fee.id">
                  <th>
                    {{ fee.fee_setting.class_fee ? fee.fee_setting.class_fee.fee.name : fee.fee_setting.fee.name}}
                  </th>
                  <td>₹ {{ fee.amount }}</td>
                  <td>₹ {{ fee.fine ? fee.fine : 0 }}</td>
                  <td>₹ {{ fee.discount_amount ? fee.discount_amount : 0 }}</td>
                  <td>
                    {{ fee.discount_percentage ? fee.discount_percentage : 0 }}%
                  </td>
                  <td>₹ {{ fee.due_amount }}</td>
                  <td>₹ {{fee.fee_total}}</td>
                  <td>
                    <!-- todo enable if required or make changes acc to school id -->
                    <a
                      href="javascript:;"
                      class="text-danger py-1"
                      @click="handleRemoveFee(fee.id)"
                      v-if="payAllOrSingle === 'PAYALL' && (isOneTimeChecked === false || (isOneTimeChecked === true && !oneTimeDiscountFeeIds.includes(fee.fee_id)))"
                    >
                      <i class="fe fe-x-square"></i>
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>

            <hr class="mt-2 mb-4" />

            <a-form class="mb-0" :form="form" @submit="handlePay">
              <div class="row" v-if="payAllOrSingle === 'PAYALL' && visibleOneTimeCheckBox">
                <div class="col-md-12 mb-2">
                <a-form-item>
                  <a-checkbox v-model="isOneTimeChecked"
                              :disabled="false">
                    Avail one time discount of Rs. {{classFeeDiscountOneTimeAmount}}.
                  </a-checkbox>
                  <a-button type="link"
                            size="small"
                            @click="handleKnowMore">Know more</a-button>
                </a-form-item>
                </div>
              </div>
              <div class="row mb-0">
                <div class="col-md-6 mb-2">
                  <div class="row">
                    <div class="col-8 col-sm-6">
                      <a-form-item class="mb-0" label="Due Amount">
                        <div style="width:150px;">
                          <a-input-number
                            placeholder="Amount"
                            v-decorator="[
                              `paid_amount`,
                              {
                                rules: [
                                  {
                                    required: true,
                                    message: 'Please input an amount!'
                                  }
                                ],
                                initialValue: this.getPayableFee(
                                  feeTotal,
                                  0,
                                  isOneTimeChecked ? classFeeDiscountOneTimeAmount : 0
                                  )}
                            ]"
                            :min="0"
                            :formatter="
                              value =>
                                `₹ ${value}`.replace(
                                  /\B(?=(\d{3})+(?!\d))/g,
                                  ','
                                )
                            "
                            :parser="value => value.replace(/\₹\s?|(,*)/g, '')"
                            style="width:100%;"
                            :disabled="true"
                          />
                        </div>
                      </a-form-item>
                    </div>
                    <!-- Payable pee -->
                    <div class="col-4 col-sm-6 mt-2">
                      <p
                        class="mt-4 mb-0 font-weight-bold text-danger"
                        v-if="feeTotal && discountType"
                      >
                        / ₹{{ getPayableFee(feeTotal,
                        0,
                        isOneTimeChecked ? classFeeDiscountOneTimeAmount : 0
                      ) }}
                      </p>
                    </div>
                  </div>
                </div>
                <div class="col-md-6 mb-2">
                  <a-form-item label="Payment Mode">
                    <a-select
                      v-decorator="[
                        'payment_type',
                        {
                          rules: [
                            {
                              required: true,
                              message: 'Please select a payment type!!'
                            }
                          ],
                          initialValue: 3
                        }
                      ]"
                      placeholder="Select payment type"
                      :disabled="true"
                    >
                      <a-select-option :value="3">
                        Online Payment
                      </a-select-option>
                    </a-select>
                  </a-form-item>
                </div>
                <div class="col-md-6 mb-2">
                  <a-form-item label="Paid by">
                    <a-input
                      placeholder="Full Name"
                      v-decorator="[
                        'paid_by',
                        {
                          rules: [
                            { required: true, message: 'Please input a name!' }
                          ]
                        }
                      ]"
                    />
                  </a-form-item>
                </div>
                <div class="col-md-6 mb-2">
                  <a-form-item label="Payment Date">
                    <a-date-picker
                      v-decorator="[
                        'payment_date',
                        {
                          rules: [
                            { required: true, message: 'Please input a date' }
                          ],
                          initialValue: moment()
                        }
                      ]"
                      :format="dateFormat"
                      :disabled="true"
                    />
                  </a-form-item>
                </div>
                <div class="col-md-12 mb-2">
                  <a-form-item label="Remark">
                    <a-input
                      placeholder="Payment remark"
                      v-decorator="[
                        'remark',
                        {
                          rules: [
                            {
                              required: false,
                              message: 'Please input a remark!'
                            }
                          ]
                        }
                      ]"
                    />
                  </a-form-item>
                </div>
              </div>
            </a-form>
          </div>
          <div v-else>
            <p class="py-4">No Fees to be paid!</p>
          </div>
        </div>
      </a-spin>
    </a-modal>

    <div class="d-none">
      <form id="redirectForm" method="post" :action="paymentUrl">
        <input type="hidden" name="appId" :value="paymentData.appId" />
        <input type="hidden" name="orderId" :value="paymentData.orderId" />
        <input
          type="hidden"
          name="orderAmount"
          :value="paymentData.orderAmount"
        />
        <input
          type="hidden"
          name="orderCurrency"
          :value="paymentData.orderCurrency"
        />
        <input type="hidden" name="orderNote" :value="paymentData.orderNote" />
        <input
          type="hidden"
          name="customerName"
          :value="paymentData.customerName"
        />
        <input
          type="hidden"
          name="customerEmail"
          :value="paymentData.customerEmail"
        />
        <input
          type="hidden"
          name="customerPhone"
          :value="paymentData.customerPhone"
        />
        <input type="hidden" name="returnUrl" :value="paymentData.returnUrl" />
        <input type="hidden" name="notifyUrl" :value="paymentData.notifyUrl" />
        <input type="hidden" name="signature" :value="paymentData.signature" />
      </form>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { mapState } from 'vuex'

import { paymentTypes } from '@/services/globaldata'

export default {
  name: 'PayStudentFees',
  props: ['schoolData'],
  data: function() {
    return {
      form: this.$form.createForm(this),
      loading: false,
      visible: false,
      spinning: false,
      dateFormat: 'DD-MM-YYYY',
      classFees: null,
      feesLoading: false,
      studentFeesData: null,
      paymentTypes,
      discountType: 'amount',
      feesToPay: [],
      feeTotal: 0,
      schoolId: null,
      studentCode: null,
      formData: null,
      paymentData: {},
      paymentUrl: '',
      totalFeePayable: 0,
      payAllOrSingle: 'SINGLE',
      isOneTimeChecked: false,
      oneTimeDiscountFeeIds: [],
      // feeDiscountOneTime: null,
      classFeeDiscountOneTimeAmount: 0,
      visibleOneTimeCheckBox: true,
    }
  },
  mounted: function() {
    this.paymentUrl = process.env.VUE_APP_CASHFREE_URL
    this.$eventBus.$on('openPublicPayStudentFeesModal', this.showModal)
  },
  computed: {
    ...mapState(['settings']),
  },
  watch: {
    feesToPay: function(val) {
      let total = 0
      val.forEach(element => {
        total = total + element.fee_total
      })
      this.feeTotal = total
      let isFeesOneTimeEnable = false
      if (this.oneTimeDiscountFeeIds.length > 0) {
        isFeesOneTimeEnable = this.oneTimeDiscountFeeIds.every(feeId => val.some(fee => fee.fee_id === feeId))
      }
      this.visibleOneTimeCheckBox = isFeesOneTimeEnable
    },
    isOneTimeChecked(isChecked) {
      // Update the paidAmount based on the isChecked value
      let amountToBePaid = this.getPayableFee(this.feeTotal,
        0,
        isChecked ? this.classFeeDiscountOneTimeAmount : 0
      )

      this.form.setFieldsValue({ paid_amount: amountToBePaid })
    },
  },
  methods: {
    moment,
    showModal: function(data, schoolId, studentCode, payAllOrSingle) {
      this.schoolId = schoolId
      this.studentCode = studentCode
      this.totalFeePayable = null
      this.visible = true
      let feeData = null
      this.payAllOrSingle = payAllOrSingle
      if (payAllOrSingle === 'PAYALL') {
        this.totalFeePayable = data.total_fee_payable
        this.studentFeesData = data.student_fees
        feeData = data.student_fees
      } else {
        this.totalFeePayable = data[0].fee_total
        this.studentFeesData = data
        feeData = data
      }

      this.oneTimeDiscountFeeIds = data.one_time_discount_fees
      this.classFeeDiscountOneTimeAmount = data.class_fee_discount_one_time ? data.class_fee_discount_one_time.amount : 0
      this.feesToPay = this.getUnpaidFees(feeData)
    },
    handlePay: function(e) {
      e.preventDefault()
      this.loading = true
      this.form.validateFields((err, values) => {
        if (!err) {
          this.$confirm({
            title: `Are you sure?`,
            content: `Click on the Pay button to pay the selected fees!`,
            okText: 'Pay',
            onOk: () => {
              const formData = this.makeEditFormData(values)
              this.formData = formData

              this.$http
                .post('/api/school/student/fees/process', formData)
                .then(({ data }) => {
                  const options = this.makeRazorpayOptions(data.data, values)
                  // eslint-disable-next-line no-undef
                  var rzp1 = new Razorpay(options)
                  rzp1.open()
                })
                .catch(error => {
                  this.loading = false
                  this.$neoNotify.error(error)
                })
            },
            onCancel: () => {
              this.loading = false
            },
          })
        }
        this.loading = false
      })
    },
    handleCancel(e) {
      this.visible = false
      this.form.resetFields()
    },
    handleReset(e) {
      this.visible = false
      this.visible = true
      this.form.resetFields()
    },
    handleKnowMore(e) {
      const h = this.$createElement
      this.$info({
        title: 'About one time discount fee',
        content: h('div', {}, [
          h('p', 'If all the tuition fees are paid at once during a specified period then fee amount for one month will be discounted from the total amount'),
          h('p', 'To avail the discount select the tick box.'),
        ]),
        onOk() {},
      })
    },
    makeFeeData: function(studentFee) {
      const fieldData = {
        fine: studentFee.fine,
        discount_amount: studentFee.discount_amount,
        discount_percentage: studentFee.discount_percentage,
      }
      return fieldData
    },
    makeEditFormData(values) {
      const studentFees = this.feesToPay.map(element => {
        return element.id
      })
      let data = {
        payment_date: moment(values.payment_date).format('YYYY-MM-DD'),
        paid_by: values.paid_by,
        remark: values.remark,
        fine: values.fine ? values.fine : 0,
        payment_type: values.payment_type,
        paid_amount: values.paid_amount,
        student_fees: studentFees,
        school_id: this.schoolId,
        student_code: this.studentCode,
        discount_code: this.isOneTimeChecked ? 'ONE_TIME_DISCOUNT' : null,
      }

      if (this.discountType === 'amount') {
        data.discount_amount = values.discount_amount
          ? values.discount_amount
          : 0
        data.discount_percentage = 0
      }
      if (this.discountType === 'percentage') {
        data.discount_amount = 0
        data.discount_percentage = values.discount_percentage
          ? values.discount_percentage
          : 0
      }
      return data
    },
    handleFeeChange(feeId) {
      const fee = find(this.classFees, { id: feeId })
      if (fee) {
        this.form.setFieldsValue({ fee_amount: fee.fee_amount })
      } else {
        this.form.setFieldsValue({ fee_amount: 0 })
      }
    },
    getUnpaidFees(fees) {
      const unPaidFees = fees.filter(element => element.payment_status !== 1)
      return unPaidFees
    },
    handleRemoveFee(feeId) {
      this.feesToPay = this.feesToPay.filter(element => element.id !== feeId)
    },
    getPayableFee(dueAmount, fine, discountAmount, discountPercentage) {
      let discount = 0
      if (this.discountType === 'amount') {
        discount = discountAmount || 0
      }
      if (this.discountType === 'percentage') {
        discount = dueAmount * (discountPercentage * 0.01) || 0
      }

      fine = fine || 0

      return dueAmount + fine - discount
    },
    makeRazorpayOptions(order, values) {
      return {
        key: order.key_id,
        amount: order.amount,
        currency: order.currency,
        name: this.schoolData.name,
        description: 'School Fee Payment',
        image: this.schoolData.logo,
        order_id: order.razorpay_order_id,
        handler: this.handlePayment,
        prefill: {
          name: values.paid_by,
          email: '',
          contact: '',
        },
      }
    },
    handlePayment(response) {
      let formData = this.formData
      formData.razorpay_response = response

      this.$http
        .post('/api/school/student/fees/pay', formData)
        .then(({ data }) => {
          this.$emit('paid', data.data)
          this.loading = false
          this.visible = false
          this.$notification['success']({
            message: 'Successfully paid',
            description: `Student fees paid successfully!`,
          })
        })
        .catch(error => {
          this.loading = false
          this.$neoNotify.error(error)
        })
    },

    handleFeePayment(e) {
      const paymentGateway = 'INSTAMOJO'
      if (paymentGateway === 'INSTAMOJO') {
        this.handleFeePaymentInstamojo(e)
      } else {
        this.handleFeePaymentCashFree(e)
      }
    },
    handleFeePaymentCashFree(e) {
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (!err) {
          this.spinning = true
          this.$confirm({
            title: `Are you sure?`,
            content: `Click on the Pay button to pay the selected fees!`,
            okText: 'Pay',
            onOk: () => {
              const formData = this.makeEditFormData(values)
              this.formData = formData
              this.$http
                .post(`/api/school/student/fees/process`, formData)
                .then(({ data }) => {
                  const paymentDetails = data.data

                  let paymentData = {
                    appId: paymentDetails.app_id,
                    orderId: paymentDetails.order_id,
                    orderAmount: paymentDetails.order_amount,
                    customerName: paymentDetails.name,
                    customerPhone: paymentDetails.phone,
                    customerEmail: paymentDetails.email,
                    notifyUrl: paymentDetails.notify_url,
                    returnUrl: paymentDetails.return_url,
                    orderNote: paymentDetails.order_note,
                    orderCurrency: paymentDetails.currency,
                    signature: paymentDetails.signature,
                  }

                  console.log(paymentData)

                  this.paymentData = paymentData

                  this.$nextTick(() => {
                    document.getElementById('redirectForm').submit()
                  })
                })
                .catch(error => {
                  this.loading = false
                  this.$neoNotify.error(error)
                })
            },
            onCancel: () => {
              this.spinning = false
              this.loading = false
            },
          })
        }
        this.loading = false
      })
    },
    handleFeePaymentInstamojo(e) {
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (!err) {
          this.spinning = true
          this.$confirm({
            title: `Are you sure?`,
            content: `Click on the Pay button to pay the selected fees!`,
            okText: 'Pay',
            onOk: () => {
              const formData = this.makeEditFormData(values)
              this.formData = formData
              this.$http
                // .post(`/api/school/student/fees/test_instamojo`, formData)
                .post(`/api/school/student/fees/process/instamojo?isMobile=0`, formData)
                .then(({ data }) => {
                  console.log(data)
                  window.location.href = data.longurl // Instamojo payment url
                })
                .catch(error => {
                  this.loading = false
                  this.spinning = false
                  this.$neoNotify.error(error)
                })
            },
            onCancel: () => {
              this.spinning = false
              this.loading = false
            },
          })
        }
        this.loading = false
      })
    },
  },
}
</script>
